import { Injectable } from '@angular/core';
import { BaseService, ServiceResponse } from '../base.service';
import { environment } from 'src/environments/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class APIService extends BaseService {
    // override recordName = 'integracion';
    procesoEnProgresoActivo: boolean = false;

    override url = `${environment.host}`;

    async pronetServicios(
        filtros: Record<string, any>
    ): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            const url = `${this.url}/pronet/servicios`;
            const resp = await lastValueFrom(
                this.http.post<any>(url, filtros, { headers: this.header })
            );
            return resp;
        } catch (error: any) {
            return this.checkError(error);
        }
    }

    async documentaServicios(
        filtros: Record<string, any>
    ): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            const url = `${this.url}/documenta/servicios`;
            const resp = await lastValueFrom(
                this.http.post<any>(url, filtros, { headers: this.header })
            );
            return resp;
        } catch (error: any) {
            return this.checkError(error);
        }
    }

    async cabalServicios(
        filtros: Record<string, any>
    ): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            const url = `${this.url}/cabal/servicios`;
            const resp = await lastValueFrom(
                this.http.post<any>(url, filtros, { headers: this.header })
            );
            return resp;
        } catch (error: any) {
            return this.checkError(error);
        }
    }

    async procesarIntegracion(
        filtros: Record<string, any>
    ): Promise<ServiceResponse> {
        try {
            if (this.procesoEnProgresoActivo === true) {
                return {
                    ok: false,
                    msg: 'No se pudo completar la operacion',
                    resp: 'Ya existe un cobro en progreso, por favor espere',
                };
            }
            this.procesoEnProgresoActivo = true;
            await this.updateToken();
            const url = `${this.url}/integracion/procesar`;
            const resp = await lastValueFrom(
                this.http.post<any>(url, filtros, { headers: this.header })
            );
            return resp;
        } catch (error: any) {
            return this.checkError(error);
        } finally {
            this.procesoEnProgresoActivo = false;
        }
    }
}
